var modalI18n = {
  close: 'Close modal'
};
export default modalI18n;